import { yupResolver } from '@hookform/resolvers/yup';
import AddIcon from '@mui/icons-material/Add';
import PersonIcon from '@mui/icons-material/Person';
import Button from '@mui/material/Button';
import Box from '@mui/material/Box';
import IconButton from '@mui/material/IconButton';
import Paper from '@mui/material/Paper';
import Stack from '@mui/material/Stack';
import Switch from '@mui/material/Switch';
import TextField from '@mui/material/TextField';
import Typography from '@mui/material/Typography';
import React, { Fragment, useEffect, useState } from 'react';
import { Controller, useForm } from "react-hook-form";
import { useParams } from 'react-router-dom';
import * as yup from "yup";
import { CreateUser, GetUsers, UpdateUser } from '../../REST/company';
import ResponsiveDialog from '../../themes/components/ResponsiveDialog';
import ToolDialogShell from '../../themes/components/ToolDialogShell';

export default function Users({
    open: openProp,
    onClose,
    showTrigger = true,
    buttonProps = {},
}) {
    const [rows, setRows] = useState([])
    const [internalOpen, setInternalOpen] = useState(false);
    const [add, setAdd] = useState(false)
    const { id } = useParams()
    const [refresh, setRefresh] = useState(false);
    const open = openProp ?? internalOpen;

    const toggleRefresh = () => setRefresh(r => !r)
    const handleClickOpen = () => {
        if (openProp === undefined) setInternalOpen(true);
    };

    const handleClose = () => {
        if (openProp === undefined) setInternalOpen(false);
        onClose?.();
    };


    useEffect(() => {
        GetData()
    }, [refresh, id])

    const GetData = () => {
        (async () => {
            const res = await GetUsers(id)
            setRows(res.data.map(e => {
                return { ...e, id: e._id }
            }))
        })()
    }

    const handleEnable = (each) => {
        (async () => {
            const res = await UpdateUser(each.id, { ...each, enable: !each.enable })
            if (res)
                GetData()
        })()
    }

    // const handleLink = (id) => navigate('/agreements/' + id)

    return (
        <Fragment>
            {showTrigger && <Button variant="contained" startIcon={<PersonIcon />} onClick={handleClickOpen} {...buttonProps}>
                Users
            </Button>}
            <ToolDialogShell
                open={open}
                onClose={handleClose}
                title="Users"
                actions={
                    <IconButton
                        size="large"
                        edge="end"
                        color="inherit"
                        aria-label="add user"
                        sx={{ mr: 2 }}
                        onClick={() => setAdd(true)}
                    >
                        <AddIcon />
                    </IconButton>
                }
            >
                {add && <AddUser open={add} handleClose={() => setAdd(false)} toggleRefresh={toggleRefresh} />}
                <Stack spacing={3}>
                    <Box>
                        <Typography variant="subtitle1" sx={{ fontWeight: 600 }}>
                            User access
                        </Typography>
                        <Typography variant="body2" color="text.secondary">
                            Manage which users can access this company.
                        </Typography>
                    </Box>

                    <Stack spacing={2}>
                        {(rows || []).map(each => (
                            <Paper key={each.id} variant="outlined" sx={{ p: 2 }}>
                                <Stack
                                    direction={{ xs: 'column', sm: 'row' }}
                                    spacing={2}
                                    justifyContent="space-between"
                                    alignItems={{ xs: 'flex-start', sm: 'center' }}
                                >
                                    <Box>
                                        <Typography variant="subtitle2" sx={{ fontWeight: 600 }}>
                                            {each.email}
                                        </Typography>
                                        <Typography variant="body2" color="text.secondary">
                                            {each.enable ? 'Access enabled' : 'Access disabled'}
                                        </Typography>
                                    </Box>

                                    <Stack direction="row" spacing={1} alignItems="center">
                                        <Typography variant="body2" color="text.secondary">
                                            Disabled
                                        </Typography>
                                        <Switch
                                            checked={!!each.enable}
                                            onChange={() => handleEnable(each)}
                                        />
                                        <Typography variant="body2" color="text.secondary">
                                            Enabled
                                        </Typography>
                                    </Stack>
                                </Stack>
                            </Paper>
                        ))}
                    </Stack>
                </Stack>
            </ToolDialogShell>

        </Fragment>
    );
}


function AddUser({ open = false, handleClose, toggleRefresh }) {
    const { id } = useParams()

    const schema = yup.object({
        email: yup.string().email().required()
    }).required();

    const { control, handleSubmit, formState: { errors }, clearErrors, reset } = useForm({
        defaultValues: {
            email: ''
        },
        resolver: yupResolver(schema)
    });

    useEffect(() => {
        clearErrors()
        reset()
    }, [open, clearErrors, reset])

    const onSubmit = (data) => {
        (async () => {
            await CreateUser(id, data)
            handleClose()
            toggleRefresh()
        })()
    }

    const isError = (val) => val !== undefined && val !== null && typeof val === 'object'


    return <ResponsiveDialog open={open} onClose={handleClose}>
        <Box sx={{ p: 3 }}>
            <Stack spacing={2}>
                <Typography variant="h6">Add User</Typography>
                <Controller name="email" control={control} render={({ field }) => <TextField error={isError(errors.email)} helperText={errors.email && errors.email.message} fullWidth label='Email' {...field} />} />
                <Stack direction="row" spacing={1} justifyContent="flex-end">
                    <Button onClick={handleClose}>Cancel</Button>
                    <Button variant="contained" onClick={handleSubmit(onSubmit)}>Save</Button>
                </Stack>
            </Stack>
        </Box>
    </ResponsiveDialog>
}
